import SERVICES from 'app-constants/service.names';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super(SERVICES.ORDERS);
  }
  getOrderList = (params) =>
    this.client.post(`/${SERVICES.ORDERS}/list`, params);
  getOrderListV2 = (params) =>
    this.client.post(`/v2/${SERVICES.ORDERS}/list`, params);
  getDetail = (orderId, payload) =>
    this.client.post(`/${SERVICES.ORDERS}/get-detail/${orderId}`, payload);
  cancelOrder = (orderId, payload) =>
    this.client.post(`/${SERVICES.ORDERS}/cancel/${orderId}`, payload);
  orderBuyUpdate = (payload) =>
    this.client.post(`/v2/${SERVICES.ORDERS}/buy-update`, payload);
  depositOrder = (orderId, payload) =>
    this.client.put(`/${SERVICES.ORDERS}/${orderId}/deposit`, payload);
  getTransportDetail = (payload) =>
    this.client.post('/v2/common/s-transport-details-fn', payload);
}

export default new Service();
